/**
 * WalkAndPunch API
 * This is the WalkAndPunch Service API.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export type FilterTypes = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12 | 13 | 14;

export const FilterTypes = {
    NUMBER_0: 0 as FilterTypes,
    NUMBER_1: 1 as FilterTypes,
    NUMBER_2: 2 as FilterTypes,
    NUMBER_3: 3 as FilterTypes,
    NUMBER_4: 4 as FilterTypes,
    NUMBER_5: 5 as FilterTypes,
    NUMBER_6: 6 as FilterTypes,
    NUMBER_7: 7 as FilterTypes,
    NUMBER_8: 8 as FilterTypes,
    NUMBER_9: 9 as FilterTypes,
    NUMBER_10: 10 as FilterTypes,
    NUMBER_11: 11 as FilterTypes,
    NUMBER_12: 12 as FilterTypes,
    NUMBER_13: 13 as FilterTypes,
    NUMBER_14: 14 as FilterTypes
};